import { uz } from "../../../../date-fns/locale/uz.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    uz
  }
};